import moment from 'moment'
// Attention!! The following line is used for localisation of dates
import 'moment/min/locales'
import * as React from 'react'
import DatePicker_ from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

import { isDateStringValid, updateHMS } from '../../../Other/functions/dateFunctions'
import { TestableInterface } from '../interfaces/TestableInterface'
import { TranslatableType } from '../interfaces/Translatable'
import { ValidatableInterface } from '../interfaces/ValidatableInterface'
import './DatePicker.scss'

type Moment = moment.Moment

export interface DatePickerPropsInterface extends TestableInterface, ValidatableInterface {
  label?: TranslatableType
  locale?: string
  format?: string
  todayButton?: string
  value: string
  onChange?: (value: string) => void
  disabled?: boolean
  minDate?: any
  maxDate?: any
  placeholder?: string
  labelPosition?: 'left' | 'top'
}

export class DatePicker extends React.Component<DatePickerPropsInterface, null> {
  public static defaultProps: DatePickerPropsInterface = {
    automation: '',
    value: '',
  }

  private isDateBetweenMinAndMax(dateStr, minDate: Moment, maxDate: Moment) {
    const date = moment(dateStr)
    return date.isBetween(minDate, maxDate)
  }

  public render(): JSX.Element {
    const { value } = this.props
    const date: Moment = value && isDateStringValid(value) ? moment(updateHMS(value)) : moment()
    const classes = ['DatePicker', 'Input', 'Controlled']
    const minDate = this.props.minDate || moment('2000-01-01')
    const maxDate = this.props.maxDate || moment('2099-12-31')

    let label

    if (this.props.labelPosition && this.props.labelPosition === 'top') {
      classes.push('LabelOnTop')
    }

    if (this.props.label) {
      label = <span className="Label">{this.props.label}</span>
    }
    if (this.props.invalid) {
      classes.push('invalid')
    }

    return (
      <div data-automation={this.props.automation} className={classes.join(' ')}>
        {label}
        <DatePicker_
          class="Controlled"
          todayButton={this.props.todayButton}
          dateFormat={this.props.format}
          selected={date}
          locale={this.props.locale}
          disabledKeyboardNavigation
          disabled={this.props.disabled}
          minDate={minDate}
          maxDate={maxDate}
          onChange={(date) => {
            // If date format is wrong, use the current date
            const nowStr = value || new Date().toISOString()
            const dateStr = date ? date.toISOString() : nowStr
            const newDate =
              isDateStringValid(dateStr) && this.isDateBetweenMinAndMax(dateStr, minDate, maxDate)
                ? updateHMS(dateStr)
                : nowStr
            this.props.onChange(newDate)
          }}
          placeholderText={this.props.placeholder}
        />
      </div>
    )
  }
}
